var map = {
	"./axia/boomea/icons/word.svg": 719955,
	"./axia/icons/word.svg": 17469,
	"./boomea/boomea/icons/word.svg": 921289,
	"./boomea/icons/word.svg": 853799,
	"./simplifi/boomea/icons/word.svg": 490843,
	"./simplifi/icons/word.svg": 768405
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 897696;
module.exports = webpackAsyncContext;